import React, { useState } from 'react';
import { motion } from "framer-motion";
import { PricingData } from '../../utils/fakeData/pricingData';
import { Link } from 'react-router-dom';
import { slideUp } from '../../utils/slideUp';
import Title from '../common/title';

import PurchaseModal from './purchaseModal';

const offers = [
  {
    createDate: "20231230183922",
    offerName: "50 點",
    offerUnit: 50,
    minVolume: 1,
    maxVolume: 9,
    offerDesc: ['相當於', '合約: 1 份，或', '智能客服對話: 1,000 字'],
  },
  {
    createDate: "20231230183922",
    offerName: "500 點",
    offerUnit: 500,
    minVolume: 1,
    maxVolume: 10,
    offerDesc: ['相當於', '合約: 10 份，或', '智能客服對話: 5,000 字'],
  },
]

const PricingGrid = () => {

  const [purchaseModal, setPurchaseModal] = useState(false);
  const togglePurchaseModal = () => { setPurchaseModal(!purchaseModal) };

  const [selectedOffer, setSelectedOffer] = useState(offers[0]);
  const [selectedOfferImage, setSelectedOfferImage] = useState(offers[0]);

  return (
    <div className="pricing-area pt-100 pb-75">
      <div className="container">

        <Title 
          sectionName={"使用方案"} 
          sectionTitle={"即用即付費，沒有隱藏成本，更可用優惠價格享受人工法律服務"} 
          sectionNameColor="#1e5651"
          sectionTitleColor="#272b3a"
          sectionNameFontSize="25px"
          sectionTitleFontSize="18px"
          style={"style-2"}
        />

        <motion.div className="row justify-content-center"
          initial="offscreen"
          whileInView="onscreen"
          variants={slideUp(1)}
          viewport={{ once: true, amount: 0.4 }}
        >
          {
            PricingData.map(({ id, features, link, plan_details, plan_name, price, time }) => {
              return (
                <div key={id} className="col-lg-4 col-md-6">
                  <div className="single-pricing-card">
                    <h3>{plan_name}</h3>
                    <div style={{ minHeight:'100px', margin: '20px 0px',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center'
                    }}>
                      <p style={{ fontSize:'16px' }}>{plan_details}</p>
                    </div>

                    <div>
                      <h1 style={{ margin:'10px 0px'}} >{price} <sub>/ {time}</sub></h1>
                      { id===2 &&
                        <div
                          style={{
                            fontSize:'18px',
                            margin: '10px 0px 30px 0px'
                          }}
                        >
                          <sub>{"≈ 10份合約"}</sub>
                        </div>
                      }

                      { id!==2 &&
                        <div
                          style={{
                            fontSize:'18px',
                            margin: '10px 0px 30px 0px'
                          }}
                        >
                          <sub style={{ visibility:'hidden' }}>{"合約"}</sub>
                        </div>
                      }
                    </div>

                    <div style={{ minHeight:'120px' }}>
                      <ul className="list-unstyled ps-0 list">
                        {
                          features.map((feature, index) => {
                            return (
                              <li key={index} className="d-flex align-items-center">
                                <i className="ri-check-double-fill"
                                  style={{
                                    backgroundColor: id === 2 ? '#fdeccb' : (id===3 ? '#e0f7ba' : undefined),
                                    color: id === 2 ? '#d6883a' : (id===3 ? '#48a004' : undefined),
                                  }}
                                ></i>
                                {feature}
                              </li>
                            )
                          })
                        }
                      </ul>
                    </div>

                    { id===1 &&
                      <button className="demo text-decoration-none" to={link}
                        style={{ backgroundColor: 'white' }}
                        onClick={()=>{
                          setSelectedOffer(offers[0]);
                          setSelectedOfferImage(offers[0]);
                          setPurchaseModal(true);
                        }}
                      >
                        <i className="ri-arrow-right-line"></i>
                        取得點數
                      </button>
                    }

                    { id===2 &&
                      <button className="demo text-decoration-none" to={link}
                        style={{ backgroundColor: 'white' }}
                        onClick={()=>{
                          setSelectedOffer(offers[1]);
                          setSelectedOfferImage(offers[1]);
                          setPurchaseModal(true);
                        }}
                      >
                        <i className="ri-arrow-right-line"></i>
                        取得點數
                      </button>
                    }

                    { id===3 &&
                      <Link className="demo text-decoration-none" to={link}>
                        <i className="ri-arrow-right-line"></i>
                        聯絡我們
                      </Link>
                    }

                  </div>
                </div>
              )
            })
          }
        </motion.div>
      </div>

      <PurchaseModal 
        offer={selectedOffer} 
        offerImage={selectedOfferImage} 
        purchaseModal={purchaseModal} 
        toggle={togglePurchaseModal}  
      />
    </div>
  )
}

export default PricingGrid;



